export const version = "rlp/5.0.4";
//# sourceMappingURL=_version.js.map